/* "I pressed Listen, so start listening."
 *
 * Pressing Listen on the fleet took two presses to produce sound: one to reach
 * the panel and one to start it. The second was never a decision -- nobody
 * arrives on the live panel having changed their mind -- so it was a step that
 * existed only because the intent did not survive the navigation.
 *
 * A module-level flag rather than a query parameter, deliberately.
 *
 * `?listen=1` would look tidier and is wrong here: starting live is not a view,
 * it writes desired state and makes a node upload a segment every second. In a
 * URL that intent survives a reload, a bookmark, a back button and a paste into
 * Slack -- so a shared link would quietly put someone else's node on air. The
 * whole point is to carry an intent exactly as far as the gesture that formed
 * it, and no further. This does not survive a reload, which is correct: a
 * reload is not someone pressing Listen.
 *
 * (It also happens to suit the router, which tracks `pathname` alone and would
 * have dropped the query -- but that is a convenience, not the reason.)
 */

let pending = false

/** Called by anything labelled Listen, immediately before navigating. */
export function armListen(): void {
  pending = true
}

/** Consume the intent. True at most once per press. */
export function takeListenIntent(): boolean {
  const was = pending
  pending = false
  return was
}
